const hideHeaderPaths = [
  { path: '/cars/', exact: true },
  { path: '/quote/', exact: false },
  { path: '/cars/deal-confirmation/', exact: false },
  { path: '/booking-confirmation/', exact: false },
  { path: '/car-drop/', exact: false },
  { path: '/campaign-cars/', exact: false },
  { path: '/car-drop/terms-and-conditions/', exact: false },
  { path: '/remind-you-later/', exact: false },

];

export const shouldHideHeader = (pathname: string): boolean => {
  return hideHeaderPaths.some(({ path, exact }) => {
    if (exact) {
      return pathname === path || pathname === `${path}`;
    } else {
      return pathname === path || pathname?.includes(`${path}`);
    }
  });
};
